import React from 'react'
import cx from 'classnames'
import { FormattedMessage } from 'sb-react-intl'

import messages from './messages'
import s from './Option.scss'


const Option = ({ children, isCurrent, isActive, onSelect, dataTestId }) => {
  const optionsClassName = cx(s.option, {
    [s.current]: isCurrent,
    [s.active]: isActive,
  })

  return (
    <div className={optionsClassName} onClick={onSelect} data-testid={dataTestId}>
      <FormattedMessage className={s.currOptionTitle} tag="div" {...messages.currOptionTitle} />
      {children}
    </div>
  )
}


export default Option
